// Platform Sidebar Navigation
// Nutzt den bestehenden .click--down Handler aus _accordion.js

// Platform Dropdown Toggle
$(document).ready(function() {
    const $dropdownToggle = $('[data-dropdown-toggle]');
    const $dropdownWrapper = $('.platform--dropdown--wrapper');
    const $body = $('body');

    if (!$dropdownToggle.length) return;

    function syncPageScrollLock() {
        const isOpen = $dropdownWrapper.hasClass('is-open');
        $body.toggleClass('platform-dropdown-open', isOpen);
    }

    // Toggle dropdown on click
    $dropdownToggle.on('click', function(e) {
        e.stopPropagation();
        $dropdownWrapper.toggleClass('is-open');
        syncPageScrollLock();
    });

    // Close dropdown when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.platform--dropdown--wrapper').length) {
            $dropdownWrapper.removeClass('is-open');
            syncPageScrollLock();
        }
    });

    // Close dropdown on Escape key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            $dropdownWrapper.removeClass('is-open');
            syncPageScrollLock();
        }
    });
});

// Optional: Scroll zum aktiven Menüpunkt beim Laden
$(document).ready(function() {
    const $activeSidebarItem = $('.platform--nav .is-current');
    if ($activeSidebarItem.length) {
        const $sidebar = $('.platform--sidebar');
        const itemOffset = $activeSidebarItem.offset().top;
        const sidebarOffset = $sidebar.offset().top;
        const sidebarHeight = $sidebar.height();
        
        // Wenn aktiver Punkt außerhalb des sichtbaren Bereichs ist, scrolle dorthin
        if (itemOffset > sidebarOffset + sidebarHeight * 0.7) {
            $sidebar.scrollTop(itemOffset - sidebarOffset - 100);
        }
    }
});

// Platform Table of Contents - Scroll Spy
$(document).ready(function() {
    const $scrollSpyNav = $('[data-scroll-spy]');
    if (!$scrollSpyNav.length) return;

    const $tocLinks = $scrollSpyNav.find('.platform--toc--link');
    const $content = $('.platform--content');
    
    if (!$tocLinks.length) return;

    // Sammle alle Ziel-Elemente
    const sections = [];
    $tocLinks.each(function() {
        const href = $(this).attr('href');
        const targetId = href.replace('#', '');
        const $target = $('#' + targetId);
        if ($target.length) {
            sections.push({
                id: targetId,
                $el: $target,
                $link: $(this)
            });
        }
    });

    if (!sections.length) return;

    // Smooth Scroll bei Klick - Native API für smootheres Scrollen
    $tocLinks.on('click', function(e) {
        e.preventDefault();
        const targetId = $(this).attr('href').replace('#', '');
        const target = document.getElementById(targetId);
        
        if (target) {
            const offset = 100; // Offset für sticky header etc.
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
            
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
            
            // Update URL ohne Scroll
            history.pushState(null, null, '#' + targetId);
        }
    });

    // Scroll Spy - Aktualisiere active Klasse beim Scrollen
    let ticking = false;
    const scrollOffset = 190; // Etwas frueher aktivieren

    function updateActiveLink() {
        const scrollPos = $(window).scrollTop();
        const winHeight = $(window).height();
        const docHeight = $(document).height();
        const triggerLine = scrollPos + scrollOffset;
        let currentSection = null;

        // Stabile Regel: Nimm die letzte Sektion, deren Top bereits ueber der Trigger-Linie liegt.
        for (let i = sections.length - 1; i >= 0; i--) {
            const section = sections[i];
            const sectionTop = section.$el.offset().top;
            
            if (sectionTop <= triggerLine) {
                currentSection = section;
                break;
            }
        }

        // Sonderfall Seitenende: letzte Sektion aktiv halten, auch wenn ihr Top nie exakt erreicht wird.
        if (scrollPos + winHeight >= docHeight - 2) {
            currentSection = sections[sections.length - 1];
        }

        // Update Klassen
        $tocLinks.removeClass('is-active');
        if (currentSection) {
            currentSection.$link.addClass('is-active');
        }

        ticking = false;
    }

    // Throttle scroll events
    $(window).on('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                updateActiveLink();
            });
            ticking = true;
        }
    });

    // Initial check
    updateActiveLink();

    // Helper function für smooth scroll
    function smoothScrollTo(targetId, offset = 100) {
        const target = document.querySelector(targetId);
        if (target) {
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }

    // Check on hash change
    $(window).on('hashchange', function() {
        const hash = window.location.hash;
        if (hash) {
            smoothScrollTo(hash);
        }
    });

    // Check if URL has hash on load
    if (window.location.hash) {
        setTimeout(function() {
            smoothScrollTo(window.location.hash);
        }, 100);
    }
});
